export default __webpack_public_path__ + "static/media/Spiral.9e0b01e1.jpg";